<!-- @format -->

@if (templateData$ | async; as templateData) {
  @if (!suggestAttainment) {
    <app-student-custom-study-draft-info
      [studyDraft]="templateData.studyDraft"
      [isSuggestButtonVisible]="templateData.isSuggestButtonVisible"
      (close)="cancel()"
      (suggestAttainment)="suggestAttainment = true"></app-student-custom-study-draft-info>
  } @else {
    <app-apply-custom-study-draft-credit
      [options]="templateData.viewOptions"
      [studyDraftName]="templateData.studyDraft.name"
      [homeUniversityName]="templateData.homeUniversityName"
      (close)="cancel()"
      (back)="suggestAttainment = false"
      (suggestedAttainment)="this.startAttainmentApplicationProcess($event)"></app-apply-custom-study-draft-credit>
  }
}
